export const language = {
    en: {
        totalBooking: "Total Booking",
        pickedUp: 'Picked Up',
        deliveredShipment: 'Delivered Shipment',
        outForDelivery: 'Out For Delivery',
        returnToOrigin: 'Return To Origin',
        bookingId: 'Booking Id',
        waybillId: 'WayBill Id',
        customerAccount: ' Customer Account',
        destination: 'Destination',
        origin: 'Origin',
        product: 'Product',
        subProduct: 'Sub-product',
        customerStatus: 'Customer Status',
        createdDate: 'Created Date',
        status: 'Status',
        createBooking: ' Create Booking',
        edit: 'Edit',
        cancel: 'Cancel',
        trackStatus: 'Track Status',
        details: 'Details',
        accountId: 'Account Id',
        accountName: 'Account Name',
        temperature: 'Temperature',
        totalPieces: 'Total Pieces',
        referenceNumber: 'Reference Number',
        weight: 'Weight',
        shipperName: 'Shipper Name',
        shipperMobile: 'Shipper Mobile',
        country: 'Country',
        pickupDateAndTime: 'Pickup Date & Time',
        subCity: 'Sub-City',
        address: 'Address',
        googleAddress: 'Google Address',
        consigneeName: 'Consignee Name',
        companyName: 'Company Name',
        consigneeMobile: 'Consignee Mobile 1',
        consigneeMobile2: 'Consignee Mobile 2',
        deliveryDate: 'Delivery Date',
        otherdetails: 'Other Details',
        shipmentValue: 'Shipment Value',
        freightCharge: 'Freight Charge',
        welcome: 'Welcome',
        customerPortal: 'Customer Portal',
        booking: 'Booking',
        report: 'Report',
        accountDetails: 'Account Details',
        shipperDetails: 'Shipper Details',
        consigneeDetails: 'Consignee Details',
        others: 'Others',
        proofOfDelivery: 'Proof of Delivery',
        fileUpload: 'File Upload & File List',
        save: 'Save',
        update: 'Update',
        saveAndDuplicate: 'Save & Duplicate',
        updateAndDuplicate: 'Update & Duplicate',
        saveAndClose: 'Save & Close',
        updateAndClose: 'Update & Close',
        numOfBox: 'Number of Box',
        numOfPallet: 'Number of Pallet',
        printWaybill: 'Print WayBill',
        printSticker: 'Print Sticker',
        addShipper: 'Add Shipper',
        addConsignee: 'Add Consignee',
        search: 'Search',
        reset: 'Reset',
        addGoogleAddress: 'Add Google Address',
        trackWayBill: 'Track WayBill',
        trackTemperature: 'Track Temperature',
        downloadFile: 'Download File',
        fileApproval: 'Image Approval',
        files: 'Uploaded Files',
        barcode: 'Barcode',
        trayBarCode: 'Rack Barcode',
        pieceBarcode: 'Pieces Barcode',
        pieceCount: 'Pieces Count',
        delete: 'Delete',
        customerReport: 'Customer Report',
        sampleTypeLSId: 'Sample Type',
        unitOfMeasureId: 'Unit Of Measure',
        mlValue: 'Sample\'s volume',
        shipmentStatus: 'Shipment Status',
        totalSamples: 'Total Samples',
        emtityName: 'Emtity Name',
        sampleBarcode: 'Sample Barcode',
        SamplesCount: 'Samples Count',
        add: 'Add',
        podFiles: 'POD files',
        podFileType: 'Pod Type',
        podRefText: 'Proof of Delivery',
        fileFormat: 'file type',
        actualUpdate: 'Actual',
        actualVmDetails: 'Actual VM Details',
        declarationValue: 'Declaration  Value',
        downloadProofOfDelivery: 'Download POD File',
        invoiceNo: 'Invoice  No',
        packingNo: 'Packing No',
        commodityDesription: 'Commodity Description',
        lifeScienceReport: 'Life Science Report',
        shortAddress: 'Short Address',
        odaRates: 'ODA Rates',
        stationName: 'Station Name',
        odaCityName: 'ODA City Name',
        basePrice: 'Base Price',
        additonalCharge: 'Additonal Charge',
        OdaRatesLabel: 'Out of Delivery Area (ODA) Rates',
        exportToExel: 'Export to Excel',
        variation: 'Variation'
    },
    ar: {
        totalBooking: "إجمالي الحجز",
        pickedUp: 'تم التحميل',
        deliveredShipment: ' الشحنات التي تم توصيلها',
        outForDelivery: 'يتم توصيلها',
        returnToOrigin: 'عائدة إلى الأصل',
        bookingId: 'رقم الحجز',
        waybillId: 'رقم الشحنة',
        customerAccount: 'حساب العميل',
        origin: 'المدينة الأصل',
        destination: 'الوجهة',
        product: 'المنتج',
        subProduct: ' المنتج الفرعي',
        customerStatus: 'حالة العميل',
        status: 'الحالة',
        createdDate: 'تاريخ الإنشاء',
        createBooking: 'حجز',
        edit: 'تعديل',
        cancel: 'الغاء',
        trackStatus: 'تتبع الحالة',
        accountId: 'معرف الحساب',
        accountName: 'اسم الحساب',
        temperature: 'درجة الحرارة',
        totalPieces: 'مجموع القطع',
        referenceNumber: 'رقم المرجع',
        weight: 'الوزن',
        shipperName: 'أسم الشاحن',
        shipperMobile: 'رقم الجوال',
        country: 'الدولة',
        pickupDateAndTime: 'تاريخ و وقت الأستلام',
        subCity: 'المدينة الفرعية',
        address: 'العنوان',
        googleAddress: 'عنوان جوجل',
        consigneeName: 'اسم المرسل إليه',
        consigneeMobile: 'رقم الجوال ١',
        consigneeMobile2: 'رقم الجوال ٢',
        deliveryDate: 'تاريخ التوصيل',
        otherdetails: 'تفاصيل اخرى',
        shipmentValue: 'قيمة الشحن',
        freightCharge: 'رسوم الشحنة',
        welcome: 'مرحبا',
        customerPortal: 'بوابة العملاء',
        booking: 'الحجز',
        accountDetails: 'تفاصيل الحساب',
        shipperDetails: 'تفاصيل الشاحن',
        consigneeDetails: 'تفاصيل المرسل إليه',
        others: 'اخرى',
        proofOfDelivery: 'اثبات التوصيل',
        save: 'حفظ',
        update: 'تحديث',
        saveAndDuplicate: 'حفظ و نسخ',
        updateAndDuplicate: 'تحديث و نسخ',
        saveAndClose: 'حفظ و اغلاق',
        updateAndClose: 'تحديث و اغلاق',
        numOfBox: 'عدد الصناديق',
        numOfPallet: 'عدد الطبليات',
        printWaybill: 'طباعة معلومات الشحنة',
        printSticker: 'طباعة الملصق',
        addShipper: 'اضافة شاحن',
        addConsignee: 'اضافة مرسل إليه',
        search: 'بحث',
        reset: 'إعادة تعيين',
        addGoogleAddress: 'اضافة عنوان جوجل',
        details: 'التفاصيل',
        trackWayBill: 'تتبع رقم بوليصة الشحنة',
        downloadFile: 'حمل الملف',
        companyName: 'أسم الشركة',
        fileUpload: 'ارفع الملف',
        files: 'ارفع الملف',
        report: 'تقرير',
        barcode: 'باركود',
        trayBarCode: 'باركود الرف',
        pieceBarcode: 'باركود القطعة',
        pieceCount: 'عدد القطع',
        delete: 'حذف',
        trackTemperature: 'تتبع الحرارة',
        customerReport: 'تقرير العملاء',
        sampleTypeLSId: 'نوع العينة',
        unitOfMeasureId: 'وحدة القياس',
        mlValue: 'كمية العينة',
        fileApproval: 'الموافقة على الصورة',
        shipmentStatus: 'حالة الشحنة',
        totalSamples: 'عدد العينات',
        emtityName: 'أسم المؤسسة',
        sampleBarcode: 'باركود العينة',
        SamplesCount: 'عدد العينات',
        add: 'اضافة',
        podFiles: 'ملفات',
        podFileType: 'نوع التحقق من الأستلام',
        podRefText: 'التحقق',
        fileFormat: 'نوع الملف',
        actualUpdate: '',
        actualVmDetails: '',
        declarationValue: 'القيمة المعلنة',
        downloadProofOfDelivery: 'تحميل ملف اثبات الأستلام',
        invoiceNo: 'رقم الفاتورة',
        packingNo: 'رقم التعبئة',
        commodityDesription: 'وصف البضائع',
        lifeScienceReport: 'تقرير علوم الحياة',
        shortAddress: 'عنوان قصير',
        odaRates: ' ODA اسعار ',
        stationName: 'أسم المحطة',
        odaCityName: 'أسم المدينة',
        basePrice: 'السعر الأساسي',
        OdaRatesLabel: 'أسعار التوصيل للمدن الفرعية',
        exportToExel: 'تحويل الى ملف أكسل',
        variation: 'Variation',
        additonalCharge: 'التكلفة الأضافية'
    }
}

